export default __webpack_public_path__ + "static/media/disney-tickets-logo-header.51b8192c.svg";